<script setup>
import { ref } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { vOnClickOutside } from '@vueuse/components';

defineProps({
  icon: {
    type: String,
    required: true,
  },
});

const showActions = ref(false);
</script>

<template>
  <div
    v-on-click-outside="() => (showActions = false)"
    class="relative flex items-center w-9 h-9 justify-center"
  >
    <Icon
      class="opacity-60 hover:opacity-100 cursor-pointer text-xl"
      :icon="icon"
      @click="showActions = !showActions"
    />
    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="opacity-0 -translate-y-2"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition ease-in duration-150"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 -translate-y-2"
    >
      <div
        v-if="showActions"
        class="absolute bottom-10 left-1/2 -translate-x-1/2 border border-n-slate-5 rounded-full shadow-lg py-1 flex flex-row z-10 bg-n-slate-7 bg-opacity-95 backdrop-blur-xs [&>button]:p-2 [&>button>span]:text-sm"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>
